import {
  BarChart3, CalendarDays, ChevronDown, ClipboardCheck, FileText, LayoutDashboard,
  Map, Menu, Moon, Package, Settings, Sun, Tractor, Users, Wrench, X
} from "lucide-react";
import { useState, type PropsWithChildren } from "react";
import { NavLink, useLocation } from "../router";
import { Brand } from "./Brand";
import { useAuth } from "../auth";
import { useTheme } from "../theme";

const navigation = [
  { label: "Vue d’ensemble", to: "/dashboard", icon: LayoutDashboard },
  { label: "Exploitations", to: "/farms", icon: Tractor },
  { label: "Parcellaire", to: "/fields", icon: Map },
  { label: "Campagnes", to: "/campaigns", icon: CalendarDays },
  { label: "Interventions", to: "/interventions", icon: ClipboardCheck },
  { label: "Planning", to: "/planning", icon: CalendarDays },
  { label: "Stocks", to: "/stocks", icon: Package },
  { label: "Matériel", to: "/equipment", icon: Wrench },
  { label: "Équipe", to: "/team", icon: Users },
  { label: "Documents", to: "/documents", icon: FileText },
  { label: "Rapports", to: "/reports", icon: BarChart3 }
];
const titles: Record<string, string> = Object.fromEntries(navigation.map(item => [item.to, item.label]));
export function AppShell({ children }: PropsWithChildren) {
  const [open, setOpen] = useState(false);
  const { identity, organizationId, selectOrganization, logout } = useAuth();
  const location = useLocation();
  const { theme, toggle } = useTheme();
  return <div className="app-shell">
    <aside className={`sidebar ${open ? "is-open" : ""}`}>
      <div className="sidebar-top"><Brand /><button className="icon-button mobile-only" onClick={() => setOpen(false)} aria-label="Fermer le menu"><X /></button></div>
      <nav aria-label="Navigation principale">
        {navigation.map(({ label, to, icon: Icon }) => <NavLink key={to} to={to} onClick={() => setOpen(false)}><Icon size={18} /><span>{label}</span></NavLink>)}
      </nav>
      <div className="sidebar-footer"><NavLink to="/settings"><Settings size={18} />Paramètres</NavLink><span className="version">AgriFlow · v0.1</span></div>
    </aside>
    {open && <button className="backdrop" onClick={() => setOpen(false)} aria-label="Fermer le menu" />}
    <div className="app-main">
      <header className="topbar">
        <div className="topbar-title"><button className="icon-button mobile-only" onClick={() => setOpen(true)} aria-label="Ouvrir le menu"><Menu /></button><h1>{titles[location.pathname] ?? "AgriFlow"}</h1></div>
        <div className="topbar-actions">
          <button className="icon-button theme-toggle" onClick={toggle} aria-label={theme === "dark" ? "Activer le thème clair" : "Activer le thème sombre"} title={theme === "dark" ? "Thème clair" : "Thème sombre"}>{theme === "dark" ? <Sun size={18}/> : <Moon size={18}/>}</button>
          <label className="organization-switcher"><span className="sr-only">Organisation</span><select value={organizationId ?? ""} onChange={(event) => selectOrganization(event.target.value)}>{identity?.memberships.map((membership) => <option key={membership.organizationId} value={membership.organizationId}>{membership.organizationName}</option>)}</select><ChevronDown size={14} /></label>
          <button className="profile" onClick={() => void logout()} title="Se déconnecter"><span className="avatar">{identity?.displayName.split(" ").map((part) => part[0]).join("").slice(0, 2)}</span><span className="profile-copy"><strong>{identity?.displayName}</strong><small>Se déconnecter</small></span></button>
        </div>
      </header>
      <main className="page">{children}</main>
    </div>
  </div>;
}
